import { styled } from "@mui/material";

export const StyledDropzone = styled("div")<{
  $disabled?: boolean;
  $active?: boolean;
  $loading?: boolean;
  $error?: boolean;
  $filled?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dashed ${({ theme }) => theme.wsc.palette.neutral[100]};
  border-radius: ${({ theme }) => theme.wsc.radius.m};
  transition: border-color 0.1s ease;
  overflow: hidden;

  ${({ $loading, $disabled, $error, theme }) =>
    !$loading &&
    !$disabled &&
    !$error &&
    `
    &:active,
    &:focus {
        border-color: ${theme.wsc.palette.primary[100]};
    }
  `}

  ${({ $active, $disabled, $loading, theme }) =>
    $active &&
    !$disabled &&
    !$loading &&
    `
    background-color: ${theme.wsc.palette.primary[700]};
    border-color: ${theme.wsc.palette.primary[100]};
  `}

  ${({ $error, $disabled, $loading, theme }) =>
    $error &&
    !$disabled &&
    !$loading &&
    `
    border-color: ${theme.wsc.palette.warning[300]};
  `}

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}

  ${({ $filled }) =>
    $filled &&
    `
    border-style: solid;
  `}
`;

export const StyledLoaderWrapper = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const StyledContentWrapper = styled("div")<{
  $loading?: boolean;
}>`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $loading }) =>
    $loading &&
    `
    opacity: 0.3;
  `}
`;
